/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { IEdmModel } from '../models/i-edm-model';
import { odata$Any } from '../fn/metadata/odata-any';
import { Odata$Any$Params } from '../fn/metadata/odata-any';
import { odata$Json } from '../fn/metadata/odata-json';
import { Odata$Json$Params } from '../fn/metadata/odata-json';
import { odata$JsonOdataMetadataFull } from '../fn/metadata/odata-json-odata-metadata-full';
import { Odata$JsonOdataMetadataFull$Params } from '../fn/metadata/odata-json-odata-metadata-full';
import { odata$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/metadata/odata-json-odata-metadata-full-odata-streaming-false';
import { Odata$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/metadata/odata-json-odata-metadata-full-odata-streaming-false';
import { odata$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/metadata/odata-json-odata-metadata-full-odata-streaming-true';
import { Odata$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/metadata/odata-json-odata-metadata-full-odata-streaming-true';
import { odata$JsonOdataMetadataMinimal } from '../fn/metadata/odata-json-odata-metadata-minimal';
import { Odata$JsonOdataMetadataMinimal$Params } from '../fn/metadata/odata-json-odata-metadata-minimal';
import { odata$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/metadata/odata-json-odata-metadata-minimal-odata-streaming-false';
import { Odata$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/metadata/odata-json-odata-metadata-minimal-odata-streaming-false';
import { odata$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/metadata/odata-json-odata-metadata-minimal-odata-streaming-true';
import { Odata$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/metadata/odata-json-odata-metadata-minimal-odata-streaming-true';
import { odata$JsonOdataMetadataNone } from '../fn/metadata/odata-json-odata-metadata-none';
import { Odata$JsonOdataMetadataNone$Params } from '../fn/metadata/odata-json-odata-metadata-none';
import { odata$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/metadata/odata-json-odata-metadata-none-odata-streaming-false';
import { Odata$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/metadata/odata-json-odata-metadata-none-odata-streaming-false';
import { odata$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/metadata/odata-json-odata-metadata-none-odata-streaming-true';
import { Odata$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/metadata/odata-json-odata-metadata-none-odata-streaming-true';
import { odata$JsonOdataStreamingFalse } from '../fn/metadata/odata-json-odata-streaming-false';
import { Odata$JsonOdataStreamingFalse$Params } from '../fn/metadata/odata-json-odata-streaming-false';
import { odata$JsonOdataStreamingTrue } from '../fn/metadata/odata-json-odata-streaming-true';
import { Odata$JsonOdataStreamingTrue$Params } from '../fn/metadata/odata-json-odata-streaming-true';
import { odata$Plain } from '../fn/metadata/odata-plain';
import { Odata$Plain$Params } from '../fn/metadata/odata-plain';
import { odata$Xml } from '../fn/metadata/odata-xml';
import { Odata$Xml$Params } from '../fn/metadata/odata-xml';
import { odataMetadata$Any } from '../fn/metadata/odata-metadata-any';
import { OdataMetadata$Any$Params } from '../fn/metadata/odata-metadata-any';
import { odataMetadata$Json } from '../fn/metadata/odata-metadata-json';
import { OdataMetadata$Json$Params } from '../fn/metadata/odata-metadata-json';
import { odataMetadata$JsonOdataMetadataFull } from '../fn/metadata/odata-metadata-json-odata-metadata-full';
import { OdataMetadata$JsonOdataMetadataFull$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-full';
import { odataMetadata$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/metadata/odata-metadata-json-odata-metadata-full-odata-streaming-false';
import { OdataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-full-odata-streaming-false';
import { odataMetadata$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/metadata/odata-metadata-json-odata-metadata-full-odata-streaming-true';
import { OdataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-full-odata-streaming-true';
import { odataMetadata$JsonOdataMetadataMinimal } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal';
import { OdataMetadata$JsonOdataMetadataMinimal$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal';
import { odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal-odata-streaming-false';
import { OdataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal-odata-streaming-false';
import { odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal-odata-streaming-true';
import { OdataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-minimal-odata-streaming-true';
import { odataMetadata$JsonOdataMetadataNone } from '../fn/metadata/odata-metadata-json-odata-metadata-none';
import { OdataMetadata$JsonOdataMetadataNone$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-none';
import { odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/metadata/odata-metadata-json-odata-metadata-none-odata-streaming-false';
import { OdataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-none-odata-streaming-false';
import { odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/metadata/odata-metadata-json-odata-metadata-none-odata-streaming-true';
import { OdataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/metadata/odata-metadata-json-odata-metadata-none-odata-streaming-true';
import { odataMetadata$JsonOdataStreamingFalse } from '../fn/metadata/odata-metadata-json-odata-streaming-false';
import { OdataMetadata$JsonOdataStreamingFalse$Params } from '../fn/metadata/odata-metadata-json-odata-streaming-false';
import { odataMetadata$JsonOdataStreamingTrue } from '../fn/metadata/odata-metadata-json-odata-streaming-true';
import { OdataMetadata$JsonOdataStreamingTrue$Params } from '../fn/metadata/odata-metadata-json-odata-streaming-true';
import { odataMetadata$Plain } from '../fn/metadata/odata-metadata-plain';
import { OdataMetadata$Plain$Params } from '../fn/metadata/odata-metadata-plain';
import { odataMetadata$Xml } from '../fn/metadata/odata-metadata-xml';
import { OdataMetadata$Xml$Params } from '../fn/metadata/odata-metadata-xml';
import { ODataServiceDocument } from '../models/o-data-service-document';

@Injectable({ providedIn: 'root' })
export class MetadataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `odataMetadata()` */
  static readonly OdataMetadataPath = '/odata/$metadata';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: OdataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue(params?: OdataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: OdataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse(params?: OdataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimal$Response(params?: OdataMetadata$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataMinimal(params?: OdataMetadata$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: OdataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFullOdataStreamingTrue(params?: OdataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: OdataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFullOdataStreamingFalse(params?: OdataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFull$Response(params?: OdataMetadata$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataFull(params?: OdataMetadata$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: OdataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue(params?: OdataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: OdataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse(params?: OdataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNone$Response(params?: OdataMetadata$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataMetadataNone(params?: OdataMetadata$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataStreamingTrue$Response(params?: OdataMetadata$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataStreamingTrue(params?: OdataMetadata$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataStreamingFalse$Response(params?: OdataMetadata$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$JsonOdataStreamingFalse(params?: OdataMetadata$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Json$Response(params?: OdataMetadata$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Json(params?: OdataMetadata$Json$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Xml$Response(params?: OdataMetadata$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Xml(params?: OdataMetadata$Xml$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Plain$Response(params?: OdataMetadata$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Plain(params?: OdataMetadata$Plain$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataMetadata$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Any$Response(params?: OdataMetadata$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
    return odataMetadata$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataMetadata$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataMetadata$Any(params?: OdataMetadata$Any$Params, context?: HttpContext): Observable<IEdmModel> {
    return this.odataMetadata$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<IEdmModel>): IEdmModel => r.body)
    );
  }

  /** Path part for operation `odata()` */
  static readonly OdataPath = '/odata';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: Odata$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimalOdataStreamingTrue(params?: Odata$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: Odata$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimalOdataStreamingFalse(params?: Odata$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimal$Response(params?: Odata$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataMinimal(params?: Odata$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: Odata$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFullOdataStreamingTrue(params?: Odata$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: Odata$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFullOdataStreamingFalse(params?: Odata$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFull$Response(params?: Odata$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataFull(params?: Odata$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: Odata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNoneOdataStreamingTrue(params?: Odata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: Odata$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNoneOdataStreamingFalse(params?: Odata$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNone$Response(params?: Odata$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataMetadataNone(params?: Odata$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataStreamingTrue$Response(params?: Odata$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataStreamingTrue(params?: Odata$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataStreamingFalse$Response(params?: Odata$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$JsonOdataStreamingFalse(params?: Odata$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Json$Response(params?: Odata$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Json(params?: Odata$Json$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Xml$Response(params?: Odata$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Xml(params?: Odata$Xml$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Plain$Response(params?: Odata$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Plain(params?: Odata$Plain$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odata$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Any$Response(params?: Odata$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
    return odata$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odata$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odata$Any(params?: Odata$Any$Params, context?: HttpContext): Observable<ODataServiceDocument> {
    return this.odata$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ODataServiceDocument>): ODataServiceDocument => r.body)
    );
  }

}
